import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppStateService } from './app-state.service';
import { AuthService } from './auth.service';
import { NavigationService } from './navigation.service';
import { ApiService } from '../api.service';
import { EnvironmentToken } from '../../util';
import { Environment } from '../../typings';

@Injectable()
export class AuthGuard  {
  private authSourceUsed = false;

  constructor(
    private authService: AuthService,
    private appStateService: AppStateService,
    private apiService: ApiService,
    private router: Router,
    private navigationService: NavigationService,
    @Inject(EnvironmentToken) private environment: Environment
  ) {}

  // eslint-disable-next-line @typescript-eslint/naming-convention
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const authSourceUrl = this.environment.matAuthSourceHost;
    if (authSourceUrl && !this.authSourceUsed) {
      this.authService.setAuthSourceUrl(authSourceUrl);
      this.authSourceUsed = true;
    }

    if (!this.authService.isFullyAuthenticated()) {
      this.appStateService.loading$.next(true);

      return this.apiService.refreshUser().pipe(
        map(() => true),
        catchError(err => {
          if (this.authService.hasAuthentication()) {
            // Authentication failed, but it wasn't a 401
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            void this.navigationService.handleError(err);
            return of(false);
          }
          return of(true);
        })
      );
    }

    return of(true);
  }
}
